import { widthScreen } from 'const/common';
import { Dialog, Stack, styled, Typography } from '@mui/material';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { StyledParams } from 'types/common';
import { ButtonCustom } from '../../../components/elements/ButtonCustom';
type ModalNoteCallProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (textNote: string) => void;
  textTitle: string;
  phoneNumber: string;
  initText?: string;
};
export const ModalNoteCall = ({
  isOpen,
  onClose,
  onSubmit,
  phoneNumber,
  textTitle,
  initText
}: ModalNoteCallProps) => {
  const [note, setNote] = useState<string>(initText ?? '');

  useEffect(() => {
    if (!isOpen) {
      setNote(initText || '');
    }
  }, [isOpen, initText]);

  return (
    <DialogStyled open={isOpen} onClose={onClose}>
      <WrapperDialog width={widthScreen < 500 ? '100%' : '420px'}>
        <Stack width={'100%'} flexDirection={'row'} justifyContent={'space-between'}>
          <Stack width={'33px'} />
          <TitleStyled>{textTitle}</TitleStyled>
          <img
            style={{ cursor: 'pointer' }}
            onClick={onClose}
            src={'/icons/icon_cancel.svg'}
            alt={'icon-cancel'}
          />
        </Stack>
        <TextStyled style={{ color: '#000' }}>Phone: {phoneNumber}</TextStyled>
        <TextStyled>Notes</TextStyled>
        <InputStyled
          placeholder={'Note'}
          value={note}
          onChange={(e: ChangeEvent<HTMLTextAreaElement>) => setNote(e.target.value as string)}
        />
        <ButtonCustom
          style={{ color: '#fff' }}
          disabled={!note}
          onClick={() => {
            onSubmit(note);
          }}
          label={'Submit'}
        />
      </WrapperDialog>
    </DialogStyled>
  );
};

const InputStyled = styled('textarea')(({ theme }: StyledParams) => ({
  width: '100%',
  height: '120px',
  borderRadius: '5px',
  padding: '10px 10px',
  border: `1px solid ${theme.colors.light1}`,
  resize: 'vertical',
  '&:focus': {
    border: `1px solid ${theme.colors.dark1}`
  },
  marginBottom: '14px'
}));
const WrapperDialog = styled(Stack)(() => ({
  borderRadius: '20px',
  flex: 1,
  padding: '15px 32px 32px 32px'
}));
const TitleStyled = styled(Typography)(({ theme }: StyledParams) => ({
  fontSize: '20px',
  fontWeight: 700,
  color: theme.colors.dark1
}));
const DialogStyled = styled(Dialog)(({ theme }: StyledParams) => ({
  [theme.breakpoints.up('sm')]: {
    '.MuiDialog-paper': {
      maxWidth: '420px'
    }
  },
  borderRadius: '20px',
  '.MuiDialog-paper': {
    margin: '20px',
    width: '100%'
  }
}));
const TextStyled = styled(Typography)(({ theme }: StyledParams) => ({
  fontSize: '18px',
  fontWeight: 500,
  color: theme.colors.light1,
  marginTop: '10px'
}));
